export const pointsConfig = {
    dataSource: [{
        text: "每日签到",

        inputs: [
            {
                component: "showIcon",
                props: {
                    label: "展示图标",
                    empty: true,
                    field:"displayIcon",
                    type: "signIn",
                    errorMessage: "图标不能为空！",
                }
            },
            {
                component: "normalInput",
                props: {
                    label: "积分值",
                    empty: true,
                    field:"integral",
                    type: "signIn",
                    errorMessage: "请输入积分值",
                    placeholder: "请输入积分值",
                }
            }, {
                component: "textareaInput",
                props: {
                    label: "规则说明",
                    empty: true,
                    width: '310px',
                    type: "signIn",
                    maxLength:200,
                    field:"discribe",
                    errorMessage: "请输入规则说明",
                    placeholder: "请输入规则说明",

                }
            }]
    },
        {
            text: "阅读首篇文章",

            inputs: [
                {
                    component: "showIcon",
                    props: {
                        label: "展示图标",
                        field:"displayIcon",
                        type: "browseFirst",
                        empty: true,
                        errorMessage: "图标不能为空！",
                    }
                },
                {
                    component: "normalInput",
                    props: {
                        label: "积分值",
                        field:"integral",
                        type: "browseFirst",
                        empty: true,
                        errorMessage: "请输入积分值",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "textareaInput",
                    props: {
                        label: "规则说明",
                        empty: true,
                        type: "browseFirst",
                        width: '310px',
                        field:"discribe",
                        maxLength:200,
                        errorMessage: "请输入规则说明",
                        placeholder: "请输入规则说明",
                    }
                }]
        }, {
            text: "阅读文章",

            inputs: [
                {
                    component: "showIcon",
                    props: {
                        label: "展示图标",
                        type: 'browse',
                        field:"displayIcon",
                        empty: true,
                        errorMessage: "图标不能为空！",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "normalInput",
                    props: {
                        label: "阅读文章数",
                        type: 'browse',
                        empty: true,
                        field:'times',
                        errorMessage: "请输入文章数",
                        placeholder: "请输入文章数",
                    }
                },
                {
                    component: "normalInput",
                    props: {
                        label: "积分值",
                        type: 'browse',
                        field:"integral",
                        empty: true,
                        errorMessage: "请输入积分值",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "textareaInput",
                    props: {
                        label: "规则说明",
                        empty: true,
                        width: '310px',
                        type: 'browse',
                        field:"discribe",
                        maxLength:200,
                        errorMessage: "请输入规则说明",
                        placeholder: "请输入规则说明",
                    }
                }]
        },
        {
            text: "观看视频",

            inputs: [
                {
                    component: "showIcon",
                    props: {
                        label: "展示图标",
                        empty: true,
                        field:"displayIcon",
                        type: "browseVideo",
                        errorMessage: "图标不能为空！",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "normalInput",
                    props: {
                        label: "次数",
                        empty: true,
                        field:'times',
                        type: "browseVideo",
                        errorMessage: "请输入次数",
                        placeholder: "请输入次数",
                    }
                },
                {
                    component: "normalInput",
                    props: {
                        label: "积分值",
                        empty: true,
                        field:"integral",
                        type: "browseVideo",
                        errorMessage: "请输入积分值",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "textareaInput",
                    props: {
                        label: "规则说明",
                        field:"discribe",
                        empty: true,
                        width: '310px',
                        maxLength:200,
                        type: "browseVideo",
                        errorMessage: "请输入规则说明",
                        placeholder: "请输入规则说明",
                    }
                }]
        },{
            text: "点赞",

            inputs: [
                {
                    component: "showIcon",
                    props: {
                        label: "展示图标",
                        field:"displayIcon",
                        type: "thumbsup",
                        empty: true,
                        errorMessage: "图标不能为空！",
                    }
                }, {
                    component: "normalInput",
                    props: {
                        label: "点赞次数",
                        empty: true,
                        type: "thumbsup",
                        field:'times',
                        errorMessage: "请输入点赞次数",
                        placeholder: "请输入点赞次数",
                    }
                },
                {
                    component: "normalInput",
                    props: {
                        label: "积分值",
                        empty: true,
                        type: "thumbsup",
                        field:"integral",
                        errorMessage: "请输入积分值",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "textareaInput",
                    props: {
                        label: "规则说明",
                        empty: true,
                        width: '310px',
                        maxLength:200,
                        field:"discribe",
                        type: "thumbsup",
                        errorMessage: "请输入规则说明",
                        placeholder: "请输入规则说明",
                    }
                }]
        },{
            text: "启动客户端",
            inputs: [
                {
                    component: "showIcon",
                    props: {
                        label: "展示图标",
                        field:"displayIcon",
                        type: "loginIn",
                        empty: true,
                        errorMessage: "图标不能为空！",
                    }
                },
                {
                    component: "normalInput",
                    props: {
                        label: "积分值",
                        field:"integral",
                        empty: true,
                        type: "loginIn",
                        errorMessage: "请输入积分值",
                        placeholder: "请输入积分值",
                    }
                }, {
                    component: "textareaInput",
                    props: {
                        label: "规则说明",
                        empty: true,
                        width: '310px',
                        type: "loginIn",
                        maxLength:200,
                        field:"discribe",
                        errorMessage: "请输入规则说明",
                        placeholder: "请输入规则说明",
                    }
                }]
        }


    ]

};